const ashcare = {
	key: 'ashcare',
	name: 'ASHCare',
	getDesignTokens: mode => ({
		mode,
		primary: {
			main: '#002D5C',
			light: '#EBF1FF',
			dark: '#001F40',
			...(mode === 'dark' && {
				main: '#42A5F5',
				dark: '#29B6F6',
				light: '#E3F2FD',
			}),
		},
		secondary: {
			main: '#0072CE',
			light: '#EBF1FF',
			dark: '#004785',
			...(mode === 'dark' && {
				main: '#009AFA',
				dark: '#1481DA',
				light: '#9EC3FF',
			}),
		},
		tertiary: {
			main: '#4F9D1A',
			light: '#EFF8E7',
			dark: '#006700',
			...(mode === 'dark' && {
				main: '#66BB6A',
				dark: '#337500',
				light: '#C2FFC6',
			}),
		},
	}),
};

export default ashcare;
